import { atom } from 'jotai'

const loadAtom = atom(true);

export default loadAtom; 


